import React from "react";
import { Pie } from "react-chartjs-2";
import "./Pei_Chart.css";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

// Register required components for ChartJS
ChartJS.register(ArcElement, Tooltip, Legend);

function Pei_Chart({ response }) {
  // Data for the pie chart
  const data = {
    labels: response?.labels,
    datasets: [
      {
        label: "Amount ₹",
        data: response?.data,
        backgroundColor: [
          "rgba(255, 99, 132, 0.6)",
          "rgba(54, 162, 235, 0.6)",
          "rgba(255, 206, 86, 0.6)",
          "rgba(75, 192, 192, 0.6)",
          "rgba(153, 102, 255, 0.6)",
        ],
        borderColor: [
          "rgba(255, 99, 132, 1)",
          "rgba(54, 162, 235, 1)",
          "rgba(255, 206, 86, 1)",
          "rgba(75, 192, 192, 1)",
          "rgba(153, 102, 255, 1)",
        ],
        borderWidth: 1,
      },
    ],
  };

  return (
    <>
      <section className="main_Chart">
        <div className="heading-holder">
          <h4>Total Amount</h4>
        </div>
        <div className="chart-holder">
          <Pie data={data} />
        </div>
      </section>
    </>
  );
}

export default Pei_Chart;
